module.exports = __webpack_public_path__ + "static/media/logo_bg.b7043bd5.svg";